import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplatePreviewComponent } from './template-preview.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

@NgModule({
  declarations: [TemplatePreviewComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    CustomFlexLayoutModule,
    PipesModule
  ],
  exports: [TemplatePreviewComponent]
})
export class TemplatePreviewModule { }
